import { render, staticRenderFns } from "./TurnaC3.vue?vue&type=template&id=34c2d080&scoped=true"
import script from "./TurnaC3.vue?vue&type=script&lang=js"
export * from "./TurnaC3.vue?vue&type=script&lang=js"
import style0 from "./TurnaC3.vue?vue&type=style&index=0&id=34c2d080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2d080",
  null
  
)

export default component.exports